import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import 'bootstrap/dist/css/bootstrap.min.css';
import { BrowserRouter, RouterProvider } from "react-router-dom"
import { Provider } from "react-redux"
import store from './Redux/Store';


const root = ReactDOM.createRoot(document.getElementById('root'));


// Empêcher l'affichage de l'écran d'erreur rouge lors des micro-rechargements dev server / proxy
if (process.env.NODE_ENV === 'development') {
  window.addEventListener('unhandledrejection', (event) => {
    if (event.reason?.response?.status === 500 || event.reason?.message?.includes('500') || event.reason?.code === 'ERR_BAD_RESPONSE') {
      event.preventDefault();
      console.warn('⚠️ Requête backend temporairement indisponible (dev proxy), tentative automatique...');
    }
  });
}

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Provider store={store}>
        < App />
      </Provider>

    </BrowserRouter>
  </React.StrictMode>
);


